(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-nail-size-picker"] && !Shopify.designMode) return;
  try {
    class CustomNailSizePicker extends HTMLElement {
    constructor() {
      super();
      this.productFormId = this.dataset.productFormId;
      this.selects = this.querySelectorAll('.custom-nail-size-picker__select');
      this.form = null;
      this.isCustomSelected = false;
    }

    connectedCallback() {
      this.form = document.getElementById(this.productFormId);
      if (!this.form) return;

      this.setupVariantObserver();
      this.checkInitialVariant();

      // bfcacheから復元された時の対応
      this.handlePageShow = this.handlePageShow.bind(this);
      window.addEventListener('pageshow', this.handlePageShow);
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.handlePageShow);
    }

    handlePageShow(event) {
      if (event.persisted) {
        this.checkInitialVariant();
      }
    }

    setupVariantObserver() {
      const variantSelects = document.querySelectorAll('variant-selects, variant-radios');
      variantSelects.forEach((variantPicker) => {
        variantPicker.addEventListener('change', () => {
          this.checkVariantSelection();
        });
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' || mutation.type === 'childList') {
            this.checkVariantSelection();
          }
        });
      });

      const productInfo = document.querySelector('product-info');
      if (productInfo) {
        observer.observe(productInfo, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['data-selected-variant'],
        });
      }
    }

    checkInitialVariant() {
      this.checkVariantSelection();
    }

    checkVariantSelection() {
      const selectedVariantText = this.getSelectedVariantText();
      const lowerText = selectedVariantText.toLowerCase();
      const isCustom = lowerText.includes('custom') || selectedVariantText.includes('カスタム');

      if (isCustom !== this.isCustomSelected) {
        this.isCustomSelected = isCustom;
        this.toggle(isCustom);
      }
    }

    getSelectedVariantText() {
      const variantSelects = document.querySelectorAll('variant-selects select, variant-radios input:checked');
      let variantText = '';

      variantSelects.forEach((input) => {
        if (input.tagName === 'SELECT') {
          variantText += ' ' + (input.options[input.selectedIndex]?.text || '');
        } else if (input.tagName === 'INPUT') {
          variantText += ' ' + (input.value || '');
        }
      });

      const selectedSwatches = document.querySelectorAll('.product-form__input input:checked');
      selectedSwatches.forEach((input) => {
        variantText += ' ' + (input.value || '');
      });

      return variantText;
    }

    toggle(show) {
      if (show) {
        this.hidden = false;
        this.enableProperties();
      } else {
        this.hidden = true;
        this.disableProperties();
      }
    }

    enableProperties() {
      this.selects.forEach((select) => {
        select.disabled = false;
        select.name = select.dataset.propertyName; // name属性を付与してFormDataに含まれるようにする
      });
    }

    disableProperties() {
      this.selects.forEach((select) => {
        select.disabled = true;
        select.removeAttribute('name'); // name属性を削除してFormDataに含まれないようにする
      });
    }
  }

  if (!customElements.get('custom-nail-size-picker')) {
    customElements.define('custom-nail-size-picker', CustomNailSizePicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tc-comment-field"] && !Shopify.designMode) return;
  try {
    class TcCommentField extends HTMLElement {
    connectedCallback() {
      this.textarea = this.querySelector('textarea');
      this.counter = this.querySelector('[data-tc-counter]');
      this.max = parseInt(this.dataset.max, 10) || 300;
      if (!this.textarea) return;

      this.onInput = this.onInput.bind(this);
      this.textarea.addEventListener('input', this.onInput);
      this.onInput();

      // 空のコメントを properties[Comment] として送らない。
      // 送ると注文にもカートにも空の項目が残って見づらい。
      this.submitGuard = (event) => {
        const form = document.getElementById(this.dataset.formId);
        if (!form || event.target !== form) return;
        if (this.textarea.value.trim() === '') {
          if (!this.textarea.dataset.tcName) this.textarea.dataset.tcName = this.textarea.name;
          this.textarea.removeAttribute('name');
        } else if (this.textarea.dataset.tcName) {
          this.textarea.name = this.textarea.dataset.tcName;
        }
      };
      document.addEventListener('submit', this.submitGuard, true);
    }

    disconnectedCallback() {
      if (this.textarea) this.textarea.removeEventListener('input', this.onInput);
      if (this.submitGuard) document.removeEventListener('submit', this.submitGuard, true);
    }

    onInput() {
      const len = this.textarea.value.length;
      if (this.counter) {
        this.counter.textContent = len + ' / ' + this.max;
        this.counter.setAttribute('data-tc-near', len >= this.max - 20 ? 'true' : 'false');
      }
    }
  }

  if (!customElements.get('tc-comment-field')) {
    customElements.define('tc-comment-field', TcCommentField);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tc-fit-selector"] && !Shopify.designMode) return;
  try {
    class TcFitSelector extends HTMLElement {
    constructor() {
      super();
      this.mode = 'none';
      this.busy = 0;
      this.ariaSetByMe = false;
    }

    // 🚩 variant-selects はノードごと差し替えられるので参照をキャッシュしない。
    // 毎回引き直す。
    get variantSelects() {
      return document.getElementById('variant-selects-' + this.dataset.sectionId);
    }

    // 🚩 フォールバックで document.querySelector('product-info') を無条件に返しては
    // いけない。同じページに <tc-fit-selector> が2つある（quick-add やFeatured product）
    // 状況で、2つ目が1つ目の product-info を掴み、互いの variant-selects を
    // 奪い合って無限に動き続ける（2026-08-04にクローン検証でブラウザが固まった）。
    // ページに product-info が1つしかないときだけフォールバックを許す。
    get productInfo() {
      const own = this.closest('product-info');
      if (own) return own;
      const all = document.querySelectorAll('product-info');
      return all.length === 1 ? all[0] : null;
    }

    connectedCallback() {
      this.form = document.getElementById(this.dataset.productFormId);
      this.modeButtons = Array.from(this.querySelectorAll('.tc-fit__mode'));
      this.panels = Array.from(this.querySelectorAll('.tc-fit__panel'));
      this.fileInputs = Array.from(this.querySelectorAll('input[type="file"][data-tc-slot]'));
      this.errorEl = this.querySelector('[data-tc-error]');

      this.maxEdge = parseInt(this.dataset.maxEdge, 10) || 1600;
      this.jpegQuality = parseFloat(this.dataset.jpegQuality) || 0.8;
      this.maxTotalBytes = parseInt(this.dataset.maxTotalBytes, 10) || 18874368;

      if (!this.form) return;

      this.kitSection = this.querySelector('[data-tc-kit]');
      this.kitSummary = this.querySelector('[data-tc-kit-summary]');
      this.kitPanel = this.querySelector('[data-tc-kit-panel]');
      this.kitToggle = this.querySelector('[data-tc-kit-toggle]');
      this.kitStatus = this.querySelector('[data-tc-kit-status]');

      this.moveNativePickerIntoPanel();
      this.boldNailShapeLabel();
      this.hideNativeKitFieldset();
      this.bindKitSummary();
      this.bindKitToggle();
      this.watchProductInfo();
      this.bindModeButtons();
      this.bindFileInputs();
      this.bindSubmitGuard();
      this.bindIosPickerFix();

      // 初期はどちらも未選択。ここで variant を動かすと
      // ?variant= 付きで来たお客様の選択をURLごと上書きしてしまう。
      this.setMode('none', { silent: true });
      this.syncBuyNowState();

      this.handlePageShow = this.handlePageShow.bind(this);
      window.addEventListener('pageshow', this.handlePageShow);
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.handlePageShow);
      if (this.submitGuard) {
        document.removeEventListener('submit', this.submitGuard, true);
      }
      if (this.nativeObserver) {
        this.nativeObserver.disconnect();
        this.nativeObserver = null;
      }
    }

    handlePageShow(event) {
      if (event.persisted) this.refreshMissingState();
    }

    /* ---------- 純正ピッカー ---------- */

    // 純正 <variant-selects>（S / M / L と Size guide リンク）を
    // Standard Size パネルの中へ物理的に移動する。
    // Taste は variant 変更のたびにノードを差し替えるが、
    // 差し替えは oldNode.parentNode.insertBefore で行われるため、
    // 一度この箱へ入れておけば以後も箱の中に残る。
    moveNativePickerIntoPanel() {
      const slot = this.querySelector('[data-tc-variant-slot]');
      const vs = this.variantSelects;
      if (!slot || !vs) return;
      if (slot.contains(vs)) return;
      slot.appendChild(vs);
    }

    /* ---------- Application Kit（2軸目のバリエーション） ---------- */

    // Application Kit の軸は純正ピッカーにも fieldset として出るが、
    // 操作はこちらのチェックボックスに一本化するので隠す。
    // 隠すだけで残すのは、Taste の variant 切替機構をそのまま使うため。
    hideNativeKitFieldset() {
      if (!this.kitSection) return;
      const fs = this.getKitFieldset();
      if (fs) fs.classList.add('tc-kit-native-hidden');
    }

    getKitFieldset() {
      const vs = this.variantSelects;
      if (!vs || !this.kitSection) return null;
      const wanted = (this.kitSection.dataset.optionName || '').trim().toLowerCase();
      const groups = vs.querySelectorAll('fieldset, .product-form__input');
      for (let i = 0; i < groups.length; i += 1) {
        const legend = groups[i].querySelector('legend, label');
        const name = legend ? (legend.textContent || '').trim().toLowerCase() : '';
        if (wanted && name.indexOf(wanted) === 0) return groups[i];
        if (name.indexOf('kit') === 0) return groups[i];
      }
      return null;
    }

    getKitRadios() {
      const fs = this.getKitFieldset();
      if (!fs) return [];
      return Array.from(fs.querySelectorAll('input[type="radio"]'));
    }

    // 「入り」とみなす値。Yes / With / +2,000 などを広めに拾い、
    // 見つからなければ2番目の選択肢を「入り」として扱う。
    isKitOnValue(value) {
      const v = (value || '').toString().trim().toLowerCase();
      return v.indexOf('yes') === 0 || v.indexOf('with') === 0 || v.indexOf('add') === 0 || v.indexOf('2,000') >= 0 || v.indexOf('2000') >= 0;
    }

    bindKitSummary() {
      if (!this.kitSummary || !this.kitPanel) return;
      this.kitSummary.addEventListener('click', () => {
        const expanded = this.kitSummary.getAttribute('aria-expanded') === 'true';
        this.kitSummary.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        this.kitPanel.hidden = expanded;
      });
    }

    bindKitToggle() {
      if (!this.kitToggle) return;

      // 現在のvariantの状態をチェックボックスへ反映
      this.syncKitToggle();

      this.kitToggle.addEventListener('change', () => {
        const radios = this.getKitRadios();
        if (radios.length === 0) return;
        let target = radios.find((r) => this.isKitOnValue(r.value) === this.kitToggle.checked);
        if (!target) {
          // 値の書き方が想定と違う場合の保険。1つ目=なし / 2つ目=あり とみなす
          target = this.kitToggle.checked ? radios[radios.length - 1] : radios[0];
        }
        if (target && !target.checked) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    syncKitToggle() {
      if (!this.kitToggle) return;
      const checked = this.getKitRadios().find((r) => r.checked);
      const selected = checked ? this.isKitOnValue(checked.value) : false;
      this.kitToggle.checked = selected;
      if (this.kitStatus) this.kitStatus.hidden = !selected;
    }

    // 客の指示で「Nail shape」のラベルを太字に。
    // main-product.liquid を書き換えず、ここでクラスを足す。
    boldNailShapeLabel() {
      const host = this.productInfo;
      if (!host) return;
      const labels = host.querySelectorAll('.product-form__input--pill > .form__label');
      labels.forEach((label) => {
        const text = (label.textContent || '').trim().toLowerCase();
        if (text.indexOf('nail shape') === 0) label.classList.add('tc-fit-bold-label');
      });
    }

    // 表示/非表示そのものは <product-info data-tc-mode> + CSS が担当する。
    // ここではノード差し替え後に「Custom選択肢を殺す」だけを当て直す。
    // 監視対象は差し替えの影響を受けない <product-info>。
    watchProductInfo() {
      const host = this.productInfo;
      if (!host || typeof MutationObserver !== 'function') return;
      this.nativeObserver = new MutationObserver(() => {
        // コールバックが触るのは class / disabled（属性）と、
        // 箱から出てしまった場合の移動だけ。
        // childList だけを監視しているので自己再帰しない。
        this.moveNativePickerIntoPanel();
        this.boldNailShapeLabel();
        this.hideNativeKitFieldset();
        this.syncKitToggle();
        this.applyCustomOptionState();
        this.syncBuyNowState();
      });
      this.nativeObserver.observe(host, { childList: true, subtree: true });
    }

    // 🚩 Application Kit の軸が増えると、ここに Kit のラジオも混ざる。
    // サイズ側の操作が Kit を掴んでしまうので、Kit の fieldset は除外する。
    getVariantRadios() {
      const vs = this.variantSelects;
      if (!vs) return [];
      const kitFs = this.getKitFieldset();
      return Array.from(vs.querySelectorAll('input[type="radio"]')).filter(
        (r) => !(kitFs && kitFs.contains(r))
      );
    }

    isCustomValue(value) {
      const v = (value || '').toString().trim().toLowerCase();
      return v.includes('custom') || (value || '').includes('カスタム');
    }

    selectVariantByPredicate(predicate) {
      const radios = this.getVariantRadios();
      const target = radios.find((r) => predicate(r.value));
      if (!target) return false;
      if (!target.checked) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }

    // Standard 側では「Custom」の選択肢を殺す。
    // hidden 属性は component-product-variant-picker.css の
    // `input[type=radio] + label { display:inline-block }` に負けるので使わない。
    applyCustomOptionState() {
      const hide = this.mode === 'standard';
      const vs = this.variantSelects;
      if (!vs) return;
      this.getVariantRadios().forEach((radio) => {
        if (!this.isCustomValue(radio.value)) return;
        const label = radio.id ? vs.querySelector('label[for="' + radio.id + '"]') : null;
        radio.classList.toggle('tc-fit-hide-option', hide);
        // disabled にしておけばラベル経由のクリックでも選択されない
        radio.disabled = hide;
        if (label) label.classList.toggle('tc-fit-hide-option', hide);
      });
    }

    /* ---------- モード切替 ---------- */

    bindModeButtons() {
      this.modeButtons.forEach((btn) => {
        btn.addEventListener('click', () => this.setMode(btn.dataset.mode));
      });
    }

    setMode(mode, options) {
      const silent = options && options.silent;
      this.mode = mode;

      const host = this.productInfo;
      if (host) host.dataset.tcMode = mode;

      this.modeButtons.forEach((btn) => {
        const on = btn.dataset.mode === mode;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.panel !== mode;
      });

      if (mode === 'custom') {
        this.applyCustomOptionState();
        this.selectVariantByPredicate((v) => this.isCustomValue(v));
        this.enableFileInputs(true);
      } else if (mode === 'standard') {
        this.applyCustomOptionState();
        // Custom が選ばれたままなら、最初の非Customへ寄せる
        const checked = this.getVariantRadios().find((r) => r.checked);
        if (!checked || this.isCustomValue(checked.value)) {
          this.selectVariantByPredicate((v) => !this.isCustomValue(v));
        }
        this.enableFileInputs(false);
      } else {
        // 未選択。variant は一切触らない
        this.applyCustomOptionState();
        this.enableFileInputs(false);
      }

      this.clearError();
      if (!silent) this.refreshMissingState();
      else this.syncBuyNowState();
    }

    // Standard 選択時にファイルが送信されないよう name を外す
    enableFileInputs(enabled) {
      this.fileInputs.forEach((input) => {
        if (enabled) {
          if (input.dataset.tcName) input.name = input.dataset.tcName;
        } else {
          if (!input.dataset.tcName) input.dataset.tcName = input.name;
          input.removeAttribute('name');
        }
      });
    }

    /* ---------- ファイル処理 ---------- */

    bindFileInputs() {
      this.fileInputs.forEach((input) => {
        input.dataset.tcName = input.name;
        input.addEventListener('change', () => this.onFileChange(input));
      });
    }

    async onFileChange(input) {
      const file = input.files && input.files[0];
      if (!file) {
        this.refreshMissingState();
        return;
      }

      this.busy += 1;
      this.setSubmitBusy(true);
      try {
        const resized = await this.resizeImage(file);
        if (resized && resized !== file) {
          const dt = new DataTransfer();
          dt.items.add(resized);
          input.files = dt.files;
        }
      } catch (e) {
        // 縮小に失敗しても元ファイルで続行する。容量は送信前に検算する
        console.warn('[tc-fit] resize skipped:', e);
      } finally {
        this.busy -= 1;
        if (this.busy <= 0) {
          this.busy = 0;
          this.setSubmitBusy(false);
        }
        this.refreshMissingState();
        this.syncUploadStatus(input);
        this.validateTotalSize();
      }
    }

    // custom.js が change 時に書いた状態を、リサイズ完了後にも同期しておく
    syncUploadStatus(input) {
      const label = input.closest('.upload-label');
      const status = label && label.querySelector('.upload-status');
      const file = input.files && input.files[0];
      if (!status) return;
      if (file) {
        status.textContent = '✓ Uploaded';
        status.setAttribute('data-has-file', 'true');
      } else {
        status.textContent = '';
        status.setAttribute('data-has-file', 'false');
      }
    }

    async resizeImage(file) {
      if (!file.type || file.type.indexOf('image/') !== 0) return file;
      if (typeof createImageBitmap !== 'function' || typeof DataTransfer !== 'function') return file;

      let bitmap;
      try {
        // imageOrientation:'from-image' を付けないと、iPhoneの縦位置写真が
        // EXIFの回転情報を失って横倒しのまま送信される
        bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
      } catch (e) {
        // 古いブラウザは第2引数を受け付けないことがある。付けずに再試行
        try {
          bitmap = await createImageBitmap(file);
        } catch (e2) {
          // HEIC など canvas がデコードできない形式はここで落ちる。元ファイルを返す
          return file;
        }
      }

      const longEdge = Math.max(bitmap.width, bitmap.height);
      const scale = longEdge > this.maxEdge ? this.maxEdge / longEdge : 1;

      // 既に十分小さくて 1.5MB 未満なら触らない
      if (scale === 1 && file.size < 1572864) {
        bitmap.close && bitmap.close();
        return file;
      }

      const w = Math.max(1, Math.round(bitmap.width * scale));
      const h = Math.max(1, Math.round(bitmap.height * scale));
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(bitmap, 0, 0, w, h);
      bitmap.close && bitmap.close();

      let quality = this.jpegQuality;
      let blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));

      // 1枚 4MB を超えるようなら段階的に品質を落とす
      let guard = 0;
      while (blob && blob.size > 4194304 && quality > 0.4 && guard < 4) {
        quality -= 0.15;
        guard += 1;
        blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
      }

      if (!blob) return file;
      if (blob.size >= file.size) return file;

      const baseName = (file.name || 'nail-photo').replace(/\.[^.]+$/, '');
      return new File([blob], baseName + '.jpg', { type: 'image/jpeg', lastModified: Date.now() });
    }

    /* ---------- 検証 ---------- */

    getMissingSlots() {
      return this.fileInputs
        .filter((input) => !(input.files && input.files.length > 0))
        .map((input) => input.dataset.tcSlot);
    }

    getTotalBytes() {
      return this.fileInputs.reduce((sum, input) => {
        const f = input.files && input.files[0];
        return sum + (f ? f.size : 0);
      }, 0);
    }

    refreshMissingState() {
      this.fileInputs.forEach((input) => {
        const row = input.closest('.upload-row');
        if (row) row.dataset.tcMissing = input.files && input.files.length > 0 ? 'false' : 'true';
      });
      this.syncBuyNowState();
    }

    get buyNowButton() {
      return document.querySelector(
        '[data-tc-buy-now][data-product-form-id="' + this.dataset.productFormId + '"]'
      );
    }

    syncBuyNowState() {
      const button = this.buyNowButton;
      const addButton = this.form && this.form.querySelector('[type="submit"]');
      if (!button || !addButton) return;

      const unavailable = addButton.disabled;
      const photosMissing = this.mode === 'custom' && this.getMissingSlots().length > 0;
      const fitDisabled = unavailable || photosMissing || this.busy > 0;
      button.dataset.tcFitDisabled = fitDisabled ? 'true' : 'false';
      button.disabled = fitDisabled || button.dataset.tcBusy === 'true';
    }

    validateTotalSize() {
      const total = this.getTotalBytes();
      if (total > this.maxTotalBytes) {
        const mb = (total / 1048576).toFixed(1);
        this.showError(
          'The photos are too large to send (' +
            mb +
            ' MB in total). Please retake them at a smaller size, or send them to us on WhatsApp after ordering.'
        );
        return false;
      }
      this.clearError();
      return true;
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    clearError() {
      if (!this.errorEl) return;
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
    }

    // 自分で立てた aria-disabled だけを外す。
    // カート追加のfetch中に product-form.js が立てたものを剥がすと二重送信の窓が開く。
    setSubmitBusy(busy) {
      const btn = this.form && this.form.querySelector('[type="submit"]');
      if (!btn) return;
      if (busy) {
        if (btn.getAttribute('aria-disabled') !== 'true') {
          btn.setAttribute('aria-disabled', 'true');
          this.ariaSetByMe = true;
        }
      } else if (this.ariaSetByMe) {
        btn.removeAttribute('aria-disabled');
        this.ariaSetByMe = false;
      }
      this.syncBuyNowState();
    }

    // product-form.js より前に走らせたいので document の capture 段階で捕まえる
    bindSubmitGuard() {
      this.submitGuard = (event) => {
        if (event.target !== this.form) return;

        if (this.mode === 'none') {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError('Please choose Custom Fit or Standard Size first.');
          this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        if (this.mode !== 'custom') return;

        if (this.busy > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError('Please wait a moment. Your photos are still being prepared.');
          return;
        }

        const missing = this.getMissingSlots();
        if (missing.length > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.refreshMissingState();
          this.showError('Please add all 4 photos: ' + missing.join(', ') + '.');
          const firstMissing = this.fileInputs.find((i) => !(i.files && i.files.length > 0));
          if (firstMissing && firstMissing.closest('.upload-row')) {
            firstMissing.closest('.upload-row').scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return;
        }

        if (!this.validateTotalSize()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      document.addEventListener('submit', this.submitGuard, true);
    }

    /* ---------- iOS: 1回目のタップで file picker が開かない問題 ---------- */

    bindIosPickerFix() {
      const isIOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (!isIOS) return;

      this.querySelectorAll('.upload-label').forEach((label) => {
        const input = label.querySelector('input[type="file"]');
        if (!input) return;
        label.addEventListener(
          'touchend',
          (e) => {
            if (e.target === input) return;
            e.preventDefault();
            e.stopPropagation();
            input.click();
          },
          { passive: false }
        );
      });
    }
  }

  if (!customElements.get('tc-fit-selector')) {
    customElements.define('tc-fit-selector', TcFitSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
